<template lang="pug">
.report-summary
  h1 年度汇总报表

  //el-button(@click='toggle_mode()') 年月切換
  el-button(@click='toggle_level()') {{level}} 级科目

  month-select(:start.sync='date_start', :end.sync='date_end', :mode='mode')

  balance-bar(:date='date_end' :state='state')

  table.ui.celled.structured.table.olive
    thead
        th.center.aligned 科目
        template(v-for='m in month')
          th.center.aligned {{m}}月
        th.center.aligned 匯總
    tbody
      tr(v-for='(row, irow) in data[level].bills', :class='{summary: irow === data[level].length - 1}')
        td(v-if='level==1') {{row._id.subject1}}
        td(v-else-if='level==2') {{row._id.subject1}} - {{row._id.subject2}}
        td(v-else-if='level==3') {{row._id.subject1}} - {{row._id.subject2}} - {{row._id.subject3}}

        template(v-for='m in month')
          td.right.aligned {{$formatters.money(((row.incomes || []).find(i=>i.month === m)||{})['income'])}}
        td.right.aligned.positive {{$formatters.money(sum_by_subject(row))}}
      tr
        td.positive 匯總
        template(v-for='m in month')
          td.right.aligned.positive {{$formatters.money(sum_by_month(m))}}
        td.right.aligned.positive {{$formatters.money(sum_total())}}
</template>

<script>
import MonthSelect from './MonthSelect.vue'
import { BalanceBar } from '../components/basic'

export default {
  name: 'report-summary',
  components: {
    MonthSelect,
    BalanceBar,
  },
  data() {
    return {
      mode: 'years',
      date_start: this.$moment(),
      date_end: this.$moment(),
      level: 1,
      data: {
        1: {},
        2: {},
        3: {},
      },
      month: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      state: 'all',
    }
  },
  watch: {
    date_start() {
      this.load(this.level)
    },
    date_end() {
      this.load(this.level)
    },
  },
  mounted() {
    this.load(this.level)
  },
  computed: {
    bills() {
      return this.$store.state.summary.bills
    },
  },
  methods: {
    sum_by_subject(row) {
      return (row.incomes || [])
        .map(i => i.income || 0)
        .reduce((a, b) => a + b, 0)
    },
    sum_by_month(m) {
      return this.data[this.level].bills
        .map(row => (row.incomes || [])
          .filter(i => i.month === m)
          .map(i => i.income || 0)
          .reduce((a, b) => a + b, 0)
        )
        .reduce((a, b) => a + b, 0)
    },
    sum_total() {
      return this.data[this.level].bills
        .map(row => (row.incomes || [])
          .map(i => i.income || 0)
          .reduce((a, b) => a + b, 0)
        )
        .reduce((a, b) => a + b, 0)
    },
    toggle_mode() {
      if (this.mode === 'years')
        this.mode = 'months'
      else
        this.mode = 'years'
    },
    toggle_level() {
      this.level += 1
      this.level = ((this.level - 1) % 3) + 1
      this.load(this.level)
    },
    load(level) {
      this.data[level] = {}
      this.$http
        .get(
          `report/summary2/by/month?level=${level}&from=${this.date_start.format()}&to=${this.date_end.format()}`
        )
        .then(data => data.json())
        .then(data => {
          this.data[level] = data
        })
        .catch(this.$utils.DefaultErrorHandler.bind(this))
    },
  },
}
</script>



// WEBPACK FOOTER //
// Summary.vue?67739b14